webpackJsonp([179408692629387],{

/***/ 200:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(20);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SecondPage = function SecondPage() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'Instruction' },
	      _react2.default.createElement(
	        'div',
	        { className: 'InstructionGroup' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Step 5: Neglect gender characteristic in training '
	        ),
	        _react2.default.createElement(
	          'progress',
	          { value: '100', max: '100' },
	          '100 %'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Another way to mitigate algorithmic bias is to remove the characteristics which might lead to unfairness (e.g., gender in the current case) from training data. This technique is called "unawareness".',
	          _react2.default.createElement('br', null),
	          _react2.default.createElement('br', null),
	          '* Without using gender as a factor to decide hiring outcomes, the only factor is now interview performance, which is irrelevant of gender. See the resulting training set below. It\'s adapted from a biased dataset.'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://docs.google.com/spreadsheets/d/1pQxhFeYGWLB5VqbYJTLjDl5d6k125Rwom_bM-qrc3N8/edit?usp=sharing', title: 'Dataset3', target: '_blank' },
	            'Dataset3'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* Now run Google Colab below again to see the results on a new batch of candidates after removing the gender characteristic in the training process. After you go to Google Colab, select "Runtime->Run all".'
	        ),
	        _react2.default.createElement(
	          'h2',
	          null,
	          _react2.default.createElement(
	            'a',
	            { href: 'https://colab.research.google.com/drive/1iIlMPTs0mqySoxUt2kOkTqgjzEWzFOBq?usp=sharing', title: 'Colab', target: '_blank' },
	            'Colab'
	          )
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          '* The results are shown under the section Training With Dataset3. Any biases noticed?'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/4-clean/' },
	          'Back'
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          'Go back to the homepage'
	        )
	      )
	    )
	  );
	};
	
	exports.default = SecondPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-5-unawareness-js-fc079833fc96d4a52e76.js